import cmp from '../../lib/cmp';
import { priceFormat } from '../utils';
import { addClass, removeClass } from '../../lib/dom/className';
import { ACTION_TYPE } from '../../config/constants';
import smEllipsis from '../../components/sm-ellipsis/sm-ellipsis';
import isVisibleRate from '../../lib/dom/element-visibility';
import onScroll from '../../lib/dom/on-page-scroll';
import { starsDetailed } from '../../lib/stars';
import { smap, shortNumber, unit } from '../../lib/utils';
import imageStar from '../../images/star';
import './sm-landing-appstore-app-1-head.less';
import { getIconSrcSet } from '../../lib/srcSetService';
import { isiPadDevice } from '../../lib/ios-device-detect';
import { isRtl } from '../../lib/document-dir-utils';



const HEADER_CLASS = 'sm-landing-appstore-app-1-head';
const HEADER_FIXED_CLASS = 'sm-landing-appstore-app-1-head__fixed';
const HEADER_IN_CLASS = 'sm-landing-appstore-app-1-head__in';
const HEADER_SHORT_CLASS = 'sm-landing-appstore-app-1-head--short';
const COMMON_INSTALL_BUTTON_CLASS = 'sm-install-button';

const INSTALL_BTN_CLASS = 'sm-landing-appstore-app-1__app-buy';
const INSTALL_BTN_CLASS_STICKY = 'sm-landing-appstore-app-1__sticky-buy';


const template = ($cmp, {
  icon,
  name,
  subheader,
  installUrl,
  features,
  price,
  currency,
  inAppPurchases,
  rating,
  reviews,
  contentRating,
  storePosition,
  category,
  stickyHeader,
  featuredBanner,
  installActionType,
  vendor,
  editorsChoiceText
}) => {
  const srcSet = getIconSrcSet(icon);
  const _category = __(category);
  const _inAppPurchases = __('sm@_in_app_purchases');
  const _installUrl = installActionType !== ACTION_TYPE.DIRECT_LINK_INSTALL ? '#' : (installUrl || '#');

  const installButton = (buttonClass) => `
    <a
      href="${_installUrl}"
      class="sm-landing-appstore-app-1-head__button ${buttonClass} ${COMMON_INSTALL_BUTTON_CLASS} ${smap(features, (feature) => `-feature-${feature}`, ' ')}"
    >
      ${priceFormat(price, currency)}
    </a>
  `;

  const getArrowTemplate = (isRtlDirection = false) => `
    <div class="sm-landing-appstore-app-1-head__fixed-placeholder${isRtlDirection ? '-rtl' : ''}">
      ${category ? `
        <div class="sm-landing-appstore-app-1-head__fixed-placeholder-icon"></div>
        <div class="sm-landing-appstore-app-1-head__fixed-placeholder-text">${_category}</div>
      ` : ''}
    </div>
  `;

  const stickyHeaderTemplate = (isRtlDirection = false) => {
    return `
      <div class="${HEADER_FIXED_CLASS}">
      <div class="img-container sm-landing-appstore-app-1-head__fixed-icon${isRtlDirection ? '-rtl' : ''}">
        <img class="" src="${icon.url}" srcset="${srcSet}"/>
      </div>
        <div class="sm-landing-appstore-app-1-head__fixed-operations${isRtlDirection ? '-rtl' : ''}">
          <div class="sm-landing-appstore-app-1-head__fixed-operations-purchases">${_inAppPurchases}</div>
          ${installButton(INSTALL_BTN_CLASS_STICKY)}
        </div>
        ${getArrowTemplate(isRtlDirection)}
      </div>
    `;
  };

  const ratingsTemplate = () => `
    <div class="sm-landing-appstore-app-1-head__ratings ${isRtl() ? 'sm-landing-appstore-app-1-head__ratings-rtl' : ''} ${editorsChoiceText ? 'with-editor-choice' : ''} ${storePosition ? 'has-store-position' : ''}">
      <div class="sm-landing-appstore-app-1-head__ratings-rating">
                  <div class="sm-landing-appstore-app-1-rating">
                      <span class="sm-landing-appstore-app-1-rating__main">
                    ${rating ? `
                      <span class="sm-landing-appstore-app-1-rating__value">
                        ${Number(rating).toFixed(1)}
                      </span>
                      ` : ''}

                    <span class="sm-landing-appstore-app-1-rating__stars">
                      ${smap(starsDetailed(rating), (star, key) => `
                        <span class="sm-landing-appstore-app-1-rating__star">${imageStar({ star, key })}</span>
                      `)}
                    </span>
                  </span>
                  <div class="sm-landing-appstore-app-1-rating__description">
                    ${editorsChoiceText && storePosition ? `${Number(rating).toFixed(1)},` : ''} ${rating ? `${shortNumber(reviews, { withDecimal: true })}${unit(reviews)} ${__('sm@_ratings')}` : __('sm@_not_enough_ratings')}
                  </div>
                </div>
            </div>
      ${editorsChoiceText ? (`<div class="editors-choice-block"><span class="editors-choice">${editorsChoiceText.replace(' ', '</br >')}</span><div>Apps</div></div>`) : ''}
      ${storePosition ? `
        <div class="sm-landing-appstore-app-1-head__ratings-category">
          <div class="sm-landing-appstore-app-1-head__ratings-category-chart">
            <span class="sm-landing-appstore-app-1-head__ratings-category-dies">#</span>
            ${storePosition}
          </div>
          <div class="sm-landing-appstore-app-1-head__ratings-category-description">${_category}</div>
        </div>
      ` : ''}

      ${contentRating ? `
        <div class="sm-landing-appstore-app-1-head__ratings-age">
          <div class="sm-landing-appstore-app-1-head__ratings-age-value">${contentRating}</div>
          <div class="sm-landing-appstore-app-1-head__ratings-age-description">${__('sm@_age')}</div>
        </div>
      ` : ''}
    </div>
  `;


  return `
    <div class="${HEADER_CLASS} ${featuredBanner ? 'sm-landing-appstore-app-1-head--banner' : ''}">
      <div class="${HEADER_IN_CLASS}">
        <div class="sm-landing-appstore-app-1-head__row">
          <div class="sm-landing-appstore-app-1-head__icon img-container">
            <img class="sm-landing-appstore-app-1-head__icon-img" src="${icon.url}" srcset="${srcSet}"/>
          </div>
          <div class="sm-landing-appstore-app-1-head__column">
            <div class="sm-landing-appstore-app-1-head__info">
              <p class="sm-landing-appstore-app-1-head__info-name">${name}</p>
              ${subheader ? $cmp('sm-landing-appstore-app-1-head__info-subheader sm-landing-appstore-app-1-head__info-subheader--h-normal', smEllipsis, { text: subheader, rows: 2 }) : ''}
              ${subheader ? $cmp('sm-landing-appstore-app-1-head__info-subheader sm-landing-appstore-app-1-head__info-subheader--h-truncated', smEllipsis, { text: subheader, rows: 1 }) : ''}
              ${(vendor && !subheader) ? $cmp('sm-landing-appstore-app-1-head__info-subheader sm-landing-appstore-app-1-head__info-subheader--h-normal', smEllipsis, { text: vendor, rows: 2 }) : ''}
              ${(vendor && !subheader) ? $cmp('sm-landing-appstore-app-1-head__info-subheader sm-landing-appstore-app-1-head__info-subheader--h-truncated', smEllipsis, { text: vendor, rows: 1 }) : ''}
            </div>
            <div class="sm-landing-appstore-app-1-head__operation">
              <div class="sm-landing-appstore-app-1-head__operation-in">
                ${installButton(INSTALL_BTN_CLASS)}
                ${inAppPurchases ? `
                  <div class="sm-landing-appstore-app-1-head__operation-purchase">
                    <div class="sm-landing-appstore-app-1-head__operation-purchase-in">
                      ${_inAppPurchases}
                    </div>
                  </div>
                ` : ''}
              </div>
            </div>
            ${isiPadDevice() ? ratingsTemplate() : ''}
          </div>
        </div>
        ${isiPadDevice() ? '' : ratingsTemplate()}
      </div>
      ${stickyHeader ? stickyHeaderTemplate(isRtl()) : ''}
    </div>
  `;
};


export default cmp(null, template, (element, { stickyHeader }) => {
  let isVisibleHeader = true;

  if (stickyHeader) {
    onScroll(() => {
      if (isVisibleHeader && !isVisibleRate(element, 0.2)) { // 20 percents of element
        isVisibleHeader = false;
        addClass(element, HEADER_SHORT_CLASS);
      } else if (!isVisibleHeader && isVisibleRate(element, 0.2)) {
        removeClass(element, HEADER_SHORT_CLASS);
        isVisibleHeader = true;
      }
    }, false, 50);
  }
});

export { INSTALL_BTN_CLASS, INSTALL_BTN_CLASS_STICKY };



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-head/sm-landing-appstore-app-1-head.js